<template>
  <EventHeaderBase :poker-run-event="pokerRunEvent" @click.stop="$emit('click')">
    <template #default>
          <div class="text-sm text-normal-standard font-medium">
            {{ formatEventDate }}
          </div>

          <div v-if="pokerRunEvent?.eventSettings" class="text-sm text-normal-reduced">
            {{ getHandsSoldDisplay(pokerRunEvent) }}
          </div>
    </template>
  </EventHeaderBase>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import Constants from "@/models/Constants";
import { PokerRunEvent } from "@/models/PokerRunEvent";
import useDate from "@/modules/useDate";
import useEvent from "@/modules/useEvent";
import EventHeaderBase from "./EventHeaderBase.vue";

const { getDateTime, getDate, formatFullDatetime } = useDate();
const { getHandsSoldDisplay } = useEvent();

const emit = defineEmits(['click']);
interface Props {
  pokerRunEvent: PokerRunEvent;
}

const props = defineProps<Props>();

const startTime = computed(() => {
  if (props.pokerRunEvent?.stops && props.pokerRunEvent?.stops[0]?.expectedArrivalTime) {
    return new Date(props.pokerRunEvent.stops[0].expectedArrivalTime);
  }
  return getDateTime(props.pokerRunEvent?.eventDate);
});

const formatEventDate = computed(() => {
  if (!startTime.value) return '';
  return formatFullDatetime(startTime.value);
});
</script>
